import { productFromFirestore } from '@parallel-fluidics/shared/models/products';
import {
  collection,
  getFirestore,
  orderBy,
  where,
} from 'firebase/firestore';
import useCustomInfiniteQuery from 'hooks/use-customInfiniteQuery';
import { useMemo } from 'react';

export default function useProductsQuery({ filterText = '', status = 'all', pageSize = 25 }) {
  const queryParams = useMemo(() => {
    const base = collection(getFirestore(), 'products');
    const queryParts = [base];
    const normalizedFilter = filterText.trim().toUpperCase();

    if (status !== 'all') {
      queryParts.push(where('status', '==', status));
    }

    if (normalizedFilter) {
      queryParts.push(orderBy('sku', 'asc'));
      queryParts.push(where('sku', '>=', normalizedFilter));
      queryParts.push(where('sku', '<=', `${normalizedFilter}\uf8ff`));
      return queryParts;
    }

    queryParts.push(orderBy('updatedAt', 'desc'));
    return queryParts;
  }, [filterText, status]);

  return useCustomInfiniteQuery({
    queryKey: 'getProductsData',
    queryParams,
    pageSize,
    transformData: productFromFirestore,
  });
}
